<template>
  <div class="content">
    <div class="top">
      <img src="../../assets/images/news.png">
      <span>暂无最新消息</span>
    </div>
    <div class='zhuti'>
      <div class="search">
        <div class="title">推荐历史</div>
        <el-form
          ref="form"
          :model="form"
          class="formBox"
        >
          <el-form-item label="企业名称">
            <div class="input">
              <el-input
                v-model="form.company"
                clearable
                placeholder="请输入企业名称"
              ></el-input>
              <span
                class='text'
                @click="search"
              ><i class="el-icon-search"></i></span>
            </div>

          </el-form-item>
          <el-form-item label="推荐开始时间">
            <!-- <el-date-picker
              class="date"
              v-model="form.applyTime"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format='yyyy年MM月'
              value-format="yyyy-MM"
              @change="handerQuery()"
            >
            </el-date-picker> -->
            <el-date-picker
              :editable="false"
              v-model="form.startTime"
              :picker-options="startDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择开始日期"
              @change='handerQuery'
            />
          </el-form-item>
          <el-form-item label="推荐结束时间">
            <el-date-picker
              :editable="false"
              v-model="form.endTime"
              :picker-options="endDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择结束日期"
              @change='handerQuery'
            />
          </el-form-item>
        </el-form>
        <el-form
          ref="form"
          :model="form"
          class="formBox1"
        >

          <div class="form-group">
            <el-form-item label="授信状态">
              <el-select
                v-model="form.credit"
                placeholder="请选择"
                clearable
                class="demand"
                @change="queryCredit()"
              >
                <el-option
                  label="是"
                  value="1"
                ></el-option>
                <el-option
                  label="否"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否关注">
              <el-select
                v-model="form.demand"
                placeholder="请选择"
                clearable
                class="demand"
                @change="query()"
              >
                <el-option
                  label="是"
                  value="1"
                ></el-option>
                <el-option
                  label="否"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="放款状态"
              class="itemRight"
            >
              <el-select
                v-model="form.lending"
                placeholder="请选择"
                clearable
                class="demand"
                @change="queryLending()"
              >
                <el-option
                  label="是"
                  value="1"
                ></el-option>
                <el-option
                  label="否"
                  value="0"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>

        </el-form>
      </div>
      <div class="export">
        <div class="top">
          <el-button
            type="text"
            class="btn"
            @click="(totle>0)?expertExcel():exExcel()"
          ><i class='el-icon-upload2'></i> 导出明细
          </el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            prop="enterpriseName"
            label="企业名称/统一代码"
            width="240"
          >
          </el-table-column>
          <el-table-column
            prop="recommendTime"
            label="推荐时间"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="isGz"
            label="是否关注"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.isGz == 1 ? '已关注' : scope.row.isGz == 0 ? '未关注' : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isSx"
            label="授信状态"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.isSx == 1 ? '已授信' : scope.row.isSx ==  0? '未授信' : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isFk"
            label="放款状态"
            width="160"
          >
            <template slot-scope="scope">
              {{ scope.row.isFk == 1 ? '已放款' : scope.row.isFk == 0 ? '未放款' : '-' }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="id"
            width="180"
          >
            <template slot-scope="scope">
              <a
                @click="viewDetails(scope.row.id)"
                style="color:#2981EE"
              >查看详情</a>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
        :show-close="false"
        custom-class="dialog1"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <div class="bodyPart">
          <div class="bodyTitle">查看详情</div>
          <div class="bodyContent">
            <div class="bodyItem">
              <div class="label">企业名称:</div>
              <div class="value">{{map.enterpriseName}}</div>
            </div>
            <div class="bodyItem">
              <div class="label">统一代码:</div>
              <div class="value">{{map.enterpriseCode}}</div>
            </div>
            <div class="bodyItem">
              <div class="label">申请时间:</div>
              <div class="value">{{map.recommendTime}}</div>
            </div>
            <div class="bodyItem">
              <div class="label">推荐时间:</div>
              <div class="value">{{map.recommendTime}}</div>
            </div>
          </div>
          <div class='recommendationDetails'>
            <el-table
              :data="list"
              style="width: 100%"
            >
              <el-table-column
                prop="bankName"
                label="推荐对象"
              >
              </el-table-column>
              <el-table-column
                prop="isGz"
                label="关注"
              >
                <template slot-scope="scope">
                  <img
                    src='../../assets/images/noSelect.png'
                    v-if='scope.row.isGz == 0'
                  />
                  <img
                    src='../../assets/images/Select.png'
                    v-else-if='scope.row.isGz == 1'
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="creditAmount"
                label="授信金额"
              >
                <template slot-scope="scope">
                  {{ scope.row.creditAmount == 0 ? '-' : scope.row.creditAmount}}
                </template>
              </el-table-column>
              <el-table-column
                prop="loanAmount"
                label="放款金额"
              >
                <template slot-scope="scope">
                  {{ scope.row.loanAmount == 0 ? '-' : scope.row.loanAmount}}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-button
            type="primary"
            class="myPrimaryButton"
            @click="confirm"
          >确认</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="block">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next"
        :total="this.totle"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { jgHistoryList, jgHistoryDetail } from "@/api/statistics"
export default {
  data () {
    return {
      form: {
        page: 1,
        size: 10,
        company: '',
        // applyTime: [],
        startTime: '',
        endTime: '',
        demand: '',
        credit: '',
        lending: ''
      },
      dialogVisible: false,
      tableData: [],
      list: [],
      map: [],
      totle: 0,
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
    }
  },
  created () {
    this.search()
  },
  methods: {
    beginDate () {
      const self = this;
      return {
        disabledDate (time) {
          if (self.form.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate () {
      const self = this;
      return {
        disabledDate (time) {
          if (self.form.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return new Date(self.form.startTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.search();
    },
    search () {
      const params = {
        appDeptName: this.form.company,
        startTime: this.form.startTime,
        endTime: this.form.endTime,
        isGz: this.form.demand,
        isSx: this.form.credit,
        isFk: this.form.lending,
        page: this.form.page,
        size: this.form.size
      }
      jgHistoryList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.totle = res.data.total
          this.tableData = res.data.list
        }
      }).catch(err => {

      })
    },
    query () {
      if (this.form.demand == null) {
        this.form.demand = ''
      }
      this.search()
    },
    queryCredit () {
      if (this.form.credit == null) {
        this.form.credit = ''
      }
      this.search()

    },
    queryLending () {
      if (this.form.lending == null) {
        this.form.lending = ''
      }
      this.search()
    },
    handerQuery () {
      if (this.form.startTime == null) {
        this.form.startTime = ''
      }
      if (this.form.endTime == null) {
        this.form.endTime = ''
      }
      this.form.page = 1
      // if (this.form.applyTime == null) {
      //   this.form.applyTime = []
      //   this.startTime = ''
      //   this.endTime = ''
      // } else {
      //   this.startTime = this.form.applyTime[0]
      //   this.endTime = this.form.applyTime[1]
      this.search()
      // }
    },
    viewDetails (val) {
      this.Details(val)
      this.dialogVisible = true;
    },
    Details (val) {
      const params = {
        id: val
      }
      jgHistoryDetail(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.list = res.data.list
          this.map = res.data.map
        }
      }).catch(err => { });
    },
    confirm () {
      this.dialogVisible = false;
    },
    exExcel () {
      this.$message.error("导出列表为空")

    },
    expertExcel () {
      // if (this.form.applyTime[0] == undefined) {
      //   this.form.applyTime[0] = ''
      // }
      // if (this.form.applyTime[1] == undefined) {
      //   this.form.applyTime[1] = ''
      // }
      const xhr = new XMLHttpRequest();
      xhr.open("post", this.baseUrl + "/api/credit/excel/expertRecommendHisExcel", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷推荐历史记录.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send("appDeptName=" + this.form.company + "&startTime=" + this.form.startTime + '&endTime=' + this.form.endTime + "&isGz=" + this.form.demand + "&isSx=" + this.form.credit + "&isFk=" + this.form.lending,);
    }

  }
}
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  min-height: 850px;
  border-radius: 8px;
  .block {
    margin-top: 20px;
    display: flex;
    justify-content: center;
  }
  .top {
    border-radius: 6px;
    font-size: 14px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2a2a2a;
    line-height: 40px;
    height: 40px;
    background-color: #fff;
    padding-left: 10px;
    img {
      margin-right: 10px;
      margin-top: 5px;
    }
  }
  .zhuti {
    background-color: #fff;
    margin-top: 24px;
    border-radius: 5px;
    .search {
      padding-top: 15px;
      .title {
        height: 24px;
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2981ee;
        line-height: 24px;
        border-left: 6px solid #2981ee;
        padding-left: 20px;
      }
      .formBox {
        margin-top: 25px;
        padding: 0 20px 0 40px;
        display: flex;
        justify-content: space-between;
        .input {
          color: #2981ee;
          display: flex;
          align-items: center;
          border: 1px solid #dde0e7;
          border-radius: 5px;
          /deep/ .el-input__inner {
            border: none;
          }
          .text {
            margin-right: 5px;
            margin-left: 5px;
            border-left: 1px solid #dde0e7;
            width: 30px;
            height: 25px;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
          }
        }
        // /deep/ .el-form-item__content {
        //   width: 200px;
        // }
        /deep/ .el-form-item {
          display: flex;
        }
        .demand {
          width: 88px !important;
        }
        .date {
          width: 240px !important;
        }
      }
      .formBox1 {
        padding: 0 20px 0 40px;
        .form-group {
          width: 63%;
          display: flex;
          justify-content: space-between;
        }
        .input {
          color: #2981ee;
          display: flex;
          align-items: center;
          border: 1px solid #dde0e7;
          border-radius: 5px;
          /deep/ .el-input__inner {
            border: none;
          }
          .text {
            margin-right: 5px;
            margin-left: 5px;
            border-left: 1px solid #dde0e7;
            width: 30px;
            height: 25px;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
          }
        }
        // /deep/ .el-form-item__content {
        //   width: 200px;
        // }
        /deep/ .el-form-item {
          display: flex;
        }
        .demand {
          width: 88px !important;
        }
        .date {
          width: 240px !important;
        }
      }
    }
    .export {
      width: 100%;
      height: 45px;
      background-color: #f5f6fa;
      display: flex;
      flex-direction: column;
      .top {
        background-color: #f5f6fa;
        display: flex;
        justify-content: flex-end;
        padding-right: 50px;
        .btn {
          width: 180px;
          height: 100%;
          background: #2981ee;
          color: #fff;
          display: flex;
          justify-content: center;
          text-align: center;
          font-size: 16px;
          font-family: Alibaba PuHuiTi;
          font-weight: 500;
          border-radius: 8px;
        }
      }
    }
    .table {
      min-height: 580px;
      /deep/ .el-table th {
        background-color: #f5f6fa !important;
        border-top: 1px solid #fff;
        text-align: center;
      }
      /deep/ .el-table td {
        text-align: center;
      }
    }
    /deep/.dialog1 {
      border-radius: 10px;
      .el-dialog__header {
        display: none;
      }
      .el-dialog__body {
        padding: 20px;
        .bodyPart {
          display: flex;
          flex-direction: column;
          align-items: center;
          .bodyTitle {
            font-size: 22px;
            color: #2a2a2a;
            font-weight: 550;
          }
          .bodyContent {
            padding: 30px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            .bodyItem {
              width: 200px;
              margin-bottom: 20px;
              padding: 0 10px;
              .label {
                background: #e7eef6;
                color: black;
                font-weight: 550;
                font-size: 16px;
                margin-bottom: 4px;
                padding-left: 8px;
              }
              .value {
                padding-left: 8px;
              }
            }
          }
        }
        .recommendationDetails {
          padding: 0 25px;
          box-sizing: border-box;
          width: 100%;
          .el-table th {
            text-align: center;
            background-color: #f5f6fa;
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #000000;
          }
          .el-table td {
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: 400;
            color: #2a2a2a;
            text-align: center;
            border: none;
          }
        }
        .myPrimaryButton {
          margin-top: 17px;
        }
      }
    }
  }
}
</style> 